import { toLocalTimeString } from './dateUtils';

export const calendarDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? new Date(value) : new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const isAllDayEvent = (event) => event.allDay === true || /^\d{4}-\d{2}-\d{2}$/.test(event.start);

const boundsForDay = (dateKey) => {
  const start = calendarDate(dateKey);
  if (!start) return null;
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  return { start, end };
};

export const eventsForDay = (events, dateKey) => {
  const day = boundsForDay(dateKey);
  if (!day) return [];
  return events.filter((event) => {
    const start = calendarDate(event.start);
    if (!start) return false;
    let end = calendarDate(event.end);
    if (!end || end <= start) {
      end = new Date(start);
      if (isAllDayEvent(event)) end.setDate(end.getDate() + 1);
      else end.setMilliseconds(end.getMilliseconds() + 1);
    }
    // Google Calendar and FullCalendar both use an exclusive end date.
    return start < day.end && end > day.start;
  }).sort((a, b) => Number(isAllDayEvent(b)) - Number(isAllDayEvent(a)) || calendarDate(a.start) - calendarDate(b.start) || a.title.localeCompare(b.title));
};

export const eventTimeForDay = (event, dateKey) => {
  if (isAllDayEvent(event)) return 'Todo el día';
  const day = boundsForDay(dateKey);
  const start = calendarDate(event.start);
  const end = calendarDate(event.end);
  if (!day || !start) return '';
  const startLabel = start < day.start ? '00:00' : toLocalTimeString(start);
  if (!end || end <= start) return startLabel;
  return `${startLabel} – ${end >= day.end ? '24:00' : toLocalTimeString(end)}`;
};
